<template>
    <div>
        <div class="main-banner">
            <div class="container">
                <!-- Navigation -->
                <div class="menu-bar">
                    <div class="logo">
                        <!-- <a href=""> -->
                            <img src="@/assets/coupon/img/img-coupon-logo-cn.svg" class="english-logo">
                        <!-- </a> -->
                    </div>
                    <div v-if='status != "signin" && $store.getters.getSessionId != null && $store.getters.getSessionId != ""'>
                        <p>{{$store.getters.getEmail}}</p>
                        <p class="v-line-blue"></p>
                        <p class='btn' v-on:click='handleSignoutClick()'>推出</p>
                    </div>
                </div>
                <h1 class="big-title">
                    {{l10.Coupon_Title1.slice(0, 7)}}<br class="mobile-show">{{l10.Coupon_Title1.slice(7)}}
                </h1>                 

                <img src="@/assets/coupon/img/img-coupon-logo.svg" class="title-deco" alt="Todo English Main Banner Logo">
                <img src="@/assets/coupon/img/img-students.svg" v-if='!isMobileOnly' class='img_students'>
                <img src="@/assets/coupon/img/img-coupon-students-m.svg" class="img_students_m mobile-show">

            </div>
        </div>

        <div id="promo1">
            <div class="container">
                <div :class='status == "signin" || status == "recover" || status == "signup" ? "current" : ""'>
                    <p class="text">
                        <span style="font-weight: 600">Step 1.</span><br>
                        {{l10.Coupon_Title2}}
                    </p>
                </div>
                <div :class='status == "coupon" ? "current" : ""'>
                    <p class="text">
                        <span style="font-weight: 600">Step 2.</span><br>
                        {{l10.Coupon_Title3}}
                    </p>
                </div>
                <div :class='status == "complete" ? "current" : ""'>
                    <p class="text">
                        <span style="font-weight: 600">Step 3.</span><br>
                        {{l10.Coupon_Title4}}
                    </p>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import { isMobileOnly } from 'mobile-device-detect'

export default {
    name: 'couponheader',
    props: ['status'],
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['en'];
        const lang = this.$store.state.lang;
	    return {
            l10:l10n,
            changedLanguage:lang,
            lang:lang,

            isMobileOnly: isMobileOnly,
        }
    },
    methods: {
        handleSignoutClick() {
            this.$store.commit('delIds')
            this.$emit('message', this.l10.Signout_Message, 'signout')
        }
    }
}
</script>
<style src="@/assets/coupon/style.css" scoped></style>
<style src="@/assets/coupon/header.css" scoped></style>


// WEBPACK FOOTER //
// src/pages/coupon/Header.vue